import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/developer/ui/entry-values")({
    beforeLoad: () => {
        throw redirect({ to: "/design/forms/entry-values", replace: true });
    },
});
